import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { fallback, zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import { TasksPage } from '@/pages/batches/Tasks.page'

const DEFAULT_SEARCH = {
  status: null,
  assetName: null,
  batchName: null,
  userGroupName: null,
  email: null,
  lastWorkedOnBy: null,
  workItemIds: null,
  taskType: null,
}

const SEARCH_SCHEMA = z.object({
  status: fallback(z.array(z.string()).nullable(), DEFAULT_SEARCH.status)
    .default(DEFAULT_SEARCH.status)
    .optional(),
  assetName: fallback(z.string().nullable(), DEFAULT_SEARCH.assetName)
    .default(DEFAULT_SEARCH.assetName)
    .optional(),
  batchName: fallback(z.string().nullable(), DEFAULT_SEARCH.batchName)
    .default(DEFAULT_SEARCH.batchName)
    .optional(),
  userGroupName: fallback(z.string().nullable(), DEFAULT_SEARCH.userGroupName)
    .default(DEFAULT_SEARCH.userGroupName)
    .optional(),
  email: fallback(z.string().nullable(), DEFAULT_SEARCH.email)
    .default(DEFAULT_SEARCH.email)
    .optional(),
  lastWorkedOnBy: fallback(z.string().nullable(), DEFAULT_SEARCH.lastWorkedOnBy)
    .default(DEFAULT_SEARCH.lastWorkedOnBy)
    .optional(),
  workItemIds: fallback(
    z.array(z.string()).nullable(),
    DEFAULT_SEARCH.workItemIds,
  )
    .default(DEFAULT_SEARCH.workItemIds)
    .optional(),
  taskType: fallback(z.string().nullable(), DEFAULT_SEARCH.taskType)
    .default(DEFAULT_SEARCH.taskType)
    .optional(),
})

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches/tasks',
)({
  component: TasksPage,
  validateSearch: zodValidator(SEARCH_SCHEMA),
  search: {
    middlewares: [stripSearchParams(DEFAULT_SEARCH)],
  },
  loader: () => ({ breadcrumbTitle: 'Tasks' }),
})
